// @ts-nocheck — Fase 5 mundo con progresión, tienda, misiones y objetos ocultos
// src/components/WorldView.ts — Fase 5
import { GAME_CONFIG, type ZoneId } from '../data/gameConfig.js';
import { store } from '../app/state.js';
import { saveLocal } from '../app/storage.js';
import { getZone } from '../world/zoneRegistry.js';
import { TILE_DEFS } from '../world/tiles.js';
import { npcsInZone } from '../entities/npc.js';
import type { NPCDef } from '../entities/npc.js';
import { InputSystem } from '../systems/inputSystem.js';
import { Camera } from '../systems/cameraSystem.js';
import { TimeSystem } from '../systems/timeSystem.js';
import { AudioSystem } from '../systems/audioSystem.js';
import { DialogueSystem } from '../systems/dialogueSystem.js';
import { canMoveTo } from '../systems/collisionSystem.js';
import { EncounterSystem, VisibleSystem } from '../systems/encounterSystem.js';
import { BattleOverlay } from './BattleOverlay.js';
import { createMenuScreen } from './MenuScreen.js';
import { createShopScreen } from './ShopScreen.js';
import { getSpecies } from '../data/asterias.js';
import { TRAINERS } from '../data/trainers.js';
import { MISSIONS } from '../data/missions.js';
import { objectsInZone } from '../world/hiddenObjects.js';
import { getItem } from '../data/items.js';
import * as MissionSystem from '../systems/missionSystem.js';
import { notify, notifyMission, notifyLevelup, notifyItem } from '../systems/notificationSystem.js';
import { addItem } from '../systems/inventorySystem.js';
import { objectsInZone } from '../world/hiddenObjects.js';
import { getItem } from '../data/items.js';
import * as MissionSystem from '../systems/missionSystem.js';
import { notify, notifyMission, notifyLevelup, notifyItem } from '../systems/notificationSystem.js';
import { addItem } from '../systems/inventorySystem.js';

export function createWorldView(): HTMLElement {
  const wrap = document.createElement('div');
  wrap.className = 'world-wrap';
  wrap.style.cssText = 'position:relative;width:100%;height:100%;display:grid;place-items:center;overflow:hidden;';

  const canvas = document.createElement('canvas');
  canvas.style.cssText = 'display:block;width:100%;height:100%;max-width:100%;max-height:100%;image-rendering:pixelated;';
  canvas.width = 960; canvas.height = 640;
  canvas.setAttribute('aria-label', 'Mundo de Aetheria');
  canvas.tabIndex = 0;

  const hud = document.createElement('div');
  hud.style.cssText = 'position:absolute;inset:0;pointer-events:none;display:flex;flex-direction:column;justify-content:space-between;padding:.6rem;';
  hud.innerHTML = `
    <div style="display:flex;justify-content:space-between;gap:.5rem;align-items:flex-start;flex-wrap:wrap;pointer-events:auto">
      <div style="display:flex;gap:.5rem;flex-wrap:wrap">
        <span class="chip" data-role="zone" style="background:rgba(0,0,0,.45);border-color:rgba(255,255,255,.14);color:#fff">—</span>
        <span class="chip" data-role="time" style="background:rgba(0,0,0,.45)">—</span>
        <span class="chip" data-role="pos" style="background:rgba(0,0,0,.45)">—</span>
        <span class="chip" data-role="trainer" style="background:rgba(106,92,255,.18);border-color:rgba(106,92,255,.35)">Nv.1</span>
        <span class="chip" data-role="aureos" style="background:rgba(255,207,107,.18);border-color:rgba(255,207,107,.35)">💰 0</span>
        <span class="chip" data-role="nucleo" style="background:rgba(124,240,255,.18);border-color:rgba(124,240,255,.35)">⬢ —</span>
        <span class="chip" data-role="team" style="background:rgba(61,214,140,.18);border-color:rgba(61,214,140,.35)">—</span>
      </div>
      <div style="display:flex;gap:.4rem;flex-wrap:wrap">
        <button data-action="menu" type="button" class="chip" style="pointer-events:auto;cursor:pointer;background:rgba(61,214,140,.92);color:#0b1020;border-color:rgba(255,255,255,.2)">☰ Menú (T)</button>
        <button data-action="map" type="button" class="chip" style="pointer-events:auto;cursor:pointer;background:rgba(106,92,255,.9);color:#fff;border-color:rgba(255,255,255,.2)">🗺 Mapa (M)</button>
        <button data-action="save" type="button" class="chip" style="pointer-events:auto;cursor:pointer;background:rgba(255,207,107,.92);color:#1a1200">💾 Guardar</button>
        <button data-action="exit" type="button" class="chip" style="pointer-events:auto;cursor:pointer;background:rgba(255,255,255,.12);color:#fff">↩ Título</button>
      </div>
    </div>
    <div style="display:flex;justify-content:space-between;align-items:flex-end;gap:.6rem;flex-wrap:wrap">
      <div data-role="controls" style="font-family:var(--font-mono);font-size:.64rem;letter-spacing:.08em;text-transform:uppercase;color:rgba(255,255,255,.85);background:rgba(0,0,0,.45);padding:.45rem .6rem;border-radius:10px;line-height:1.5">
        <span style="color:var(--accent)">WASD</span> mover · <span style="color:var(--accent)">ESPACIO</span> hablar/coger · <span style="color:var(--accent)">T</span> menú · <span style="color:var(--accent)">M</span> mapa
      </div>
      <div data-role="minimap-wrap" style="width:132px;height:96px;border-radius:12px;overflow:hidden;border:1px solid rgba(255,255,255,.18);background:rgba(0,0,0,.45);backdrop-filter:blur(6px);display:grid;place-items:center">
        <canvas data-role="minimap" width="132" height="96" style="width:100%;height:100%;image-rendering:pixelated"></canvas>
      </div>
    </div>
  `;

  const prompt = document.createElement('div');
  prompt.style.cssText = 'position:absolute;left:50%;top:62%;transform:translate(-50%,-50%);pointer-events:none;display:none;z-index:5;';
  prompt.innerHTML = `<span style="font-family:var(--font-mono);font-size:.72rem;letter-spacing:.12em;text-transform:uppercase;background:rgba(0,0,0,.78);color:#fff;border:1px solid rgba(124,240,255,.5);padding:.35rem .6rem;border-radius:999px;box-shadow:0 4px 16px rgba(0,0,0,.4)">[ ESPACIO ] hablar</span>`;

  const dialogueEl = document.createElement('div');
  dialogueEl.style.cssText = 'position:absolute;left:50%;bottom:1rem;transform:translateX(-50%);width:min(640px,92%);display:none;z-index:10;pointer-events:auto;';
  dialogueEl.innerHTML = `
    <div style="background:linear-gradient(180deg, rgba(18,26,51,.97), rgba(14,20,42,.99));border:1px solid rgba(255,255,255,.12);border-radius:16px;box-shadow:0 16px 40px rgba(0,0,0,.5);overflow:hidden;backdrop-filter:blur(10px)">
      <div data-role="dlg-name" style="padding:.6rem .9rem .35rem;font-family:var(--font-display);font-weight:800;letter-spacing:.04em;color:var(--accent)">—</div>
      <div data-role="dlg-text" style="padding:.2rem .9rem .7rem;color:var(--text);line-height:1.6;min-height:3.2rem;font-size:.95rem"></div>
      <div style="display:flex;justify-content:flex-end;padding:0 .9rem .7rem"><span style="font-family:var(--font-mono);font-size:.66rem;letter-spacing:.12em;text-transform:uppercase;color:var(--muted);border:1px solid rgba(255,255,255,.1);padding:.25rem .5rem;border-radius:999px">ESPACIO ↵</span></div>
    </div>
  `;

  const touch = document.createElement('div');
  touch.style.cssText = 'position:absolute;left:.6rem;bottom:5.2rem;display:none;gap:.35rem;z-index:6;pointer-events:auto;';
  touch.innerHTML = `
    <div style="display:grid;grid-template-columns:44px 44px 44px;grid-template-rows:44px 44px 44px;gap:6px">
      <span></span><button data-dir="up" style="width:44px;height:44px;border-radius:12px;border:1px solid rgba(255,255,255,.18);background:rgba(0,0,0,.45);color:#fff;font-size:18px">▲</button><span></span>
      <button data-dir="left" style="width:44px;height:44px;border-radius:12px;border:1px solid rgba(255,255,255,.18);background:rgba(0,0,0,.45);color:#fff;font-size:18px">◀</button><button data-dir="interact" style="width:44px;height:44px;border-radius:999px;border:1px solid rgba(124,240,255,.5);background:rgba(124,240,255,.22);color:#fff;font-size:14px">A</button><button data-dir="right" style="width:44px;height:44px;border-radius:12px;border:1px solid rgba(255,255,255,.18);background:rgba(0,0,0,.45);color:#fff;font-size:18px">▶</button>
      <span></span><button data-dir="down" style="width:44px;height:44px;border-radius:12px;border:1px solid rgba(255,255,255,.18);background:rgba(0,0,0,.45);color:#fff;font-size:18px">▼</button><span></span>
    </div>
  `;

  const mapOverlay = document.createElement('div');
  mapOverlay.style.cssText = 'position:absolute;inset:0;background:rgba(7,11,26,.86);backdrop-filter:blur(10px);display:none;z-index:12;place-items:center;padding:1rem;';
  mapOverlay.innerHTML = `
    <div style="width:min(720px,96vw);max-height:92vh;overflow:auto;background:linear-gradient(180deg, rgba(18,26,51,.98), rgba(14,20,42,.99));border:1px solid rgba(255,255,255,.12);border-radius:18px;box-shadow:0 20px 60px rgba(0,0,0,.5);padding:1rem">
      <div style="display:flex;justify-content:space-between;align-items:center;gap:.75rem;margin-bottom:.8rem">
        <div>
          <div class="kicker">Atlas de Aetheria</div>
          <div style="font-family:var(--font-display);font-weight:800;font-size:1.3rem">Mapa del mundo — Fase 5</div>
          <div style="font-size:.82rem;color:var(--muted)">Villa ↔ Ruta · 6 Asterias · Objetos ocultos brillan</div>
        </div>
        <button data-close-map type="button" class="btn btn--ghost" style="width:auto;padding:.6rem .9rem">✕ Cerrar (M)</button>
      </div>
      <div data-role="map-grid" style="display:grid;grid-template-columns:1fr 1fr;gap:.8rem">
        <div style="border:1px solid rgba(255,255,255,.08);border-radius:14px;overflow:hidden;background:rgba(255,255,255,.02)"><div style="padding:.6rem .75rem;font-weight:800">Villa Aurelia</div><canvas data-role="map-villa" width="340" height="272" style="width:100%;height:auto;display:block;image-rendering:pixelated"></canvas><div style="padding:.5rem .75rem;font-size:.78rem;color:var(--muted)">Segura · objetos ocultos · sin encuentros</div></div>
        <div style="border:1px solid rgba(255,255,255,.08);border-radius:14px;overflow:hidden;background:rgba(255,255,255,.02)"><div style="padding:.6rem .75rem;font-weight:800">Ruta Aurelia</div><canvas data-role="map-ruta" width="340" height="298" style="width:100%;height:auto;display:block;image-rendering:pixelated"></canvas><div style="padding:.5rem .75rem;font-size:.78rem;color:var(--muted)">Hierba alta + visibles + objetos</div></div>
      </div>
      <div style="margin-top:.8rem;display:flex;gap:.5rem;flex-wrap:wrap">
        <span class="chip">● Tu posición</span><span class="chip">■ Warp</span><span class="chip">● NPC</span><span class="chip" style="background:rgba(255,207,107,.15)">⬢ Asteria</span><span class="chip" style="background:rgba(124,240,255,.15)">✦ Objeto</span>
      </div>
    </div>
  `;

  const fade = document.createElement('div');
  fade.style.cssText = 'position:absolute;inset:0;background:#070b1a;opacity:0;pointer-events:none;transition:opacity .35s ease;z-index:9;';

  wrap.append(canvas, hud, prompt, dialogueEl, touch, mapOverlay, fade);
  if ('ontouchstart' in window || window.matchMedia('(max-width: 860px)').matches) touch.style.display='grid';

  const ctx = canvas.getContext('2d')!;
  const minimap = hud.querySelector<HTMLCanvasElement>('[data-role="minimap"]')!;
  const mctx = minimap.getContext('2d')!;
  const zoneLabel = hud.querySelector<HTMLSpanElement>('[data-role="zone"]')!;
  const timeLabel = hud.querySelector<HTMLSpanElement>('[data-role="time"]')!;
  const posLabel = hud.querySelector<HTMLSpanElement>('[data-role="pos"]')!;
  const trainerLabel = hud.querySelector<HTMLSpanElement>('[data-role="trainer"]')!;
  const aureosLabel = hud.querySelector<HTMLSpanElement>('[data-role="aureos"]')!;
  const nucleoLabel = hud.querySelector<HTMLSpanElement>('[data-role="nucleo"]')!;
  const teamLabel = hud.querySelector<HTMLSpanElement>('[data-role="team"]')!;
  const dlgName = dialogueEl.querySelector<HTMLDivElement>('[data-role="dlg-name"]')!;
  const dlgText = dialogueEl.querySelector<HTMLDivElement>('[data-role="dlg-text"]')!;

  const input = new InputSystem(); input.attach();

  let zoneId: ZoneId = store.get().world.zoneId;
  let zone = getZone(zoneId);
  let player = {
    x: store.get().world.position.x,
    y: store.get().world.position.y,
    facing: store.get().world.facing as 'north'|'south'|'east'|'west',
    moving:false, animTick:0,
  };
  if(player.x<0||player.x>=zone.size.w||player.y<0||player.y>=zone.size.h){ player.x=14; player.y=12; }

  const camera = new Camera(canvas.width, canvas.height);
  const time = new TimeSystem(store.get().time?.tick ?? 0.25);
  const audio = new AudioSystem();
  const dialogue = new DialogueSystem();
  (window as any).aetheriaAudio = audio;
  dialogue.setSpeed(store.getOptions().textSpeed);
  store.subscribeOptions(o=> dialogue.setSpeed(o.textSpeed));

  let npcs: NPCDef[] = npcsInZone(zoneId);
  let nearbyNpc: NPCDef | null = null;
  let nearbySign: {x:number,y:number,text:string[]} | null = null;
  let nearbyVisible: string | null = null;
  let nearbyHidden: string | null = null;
  let transitioning=false, mapOpen=false, menuOpen=false;
  let lastTime=performance.now(), saveAcc=0, timeAcc=0;
  let lastTileX = Math.round(player.x), lastTileY = Math.round(player.y);
  let menuOverlay: HTMLElement | null = null;
  let shopOverlay: HTMLElement | null = null;

  const encounterSystem = new EncounterSystem();
  const visibleSystem = new VisibleSystem();

  audio.setVolume(store.getOptions().masterVolume * store.getOptions().sfxVolume);

  const battle = new BattleOverlay({
    onCaptureSuccess: (_sp, _lvl)=> {
      encounterSystem.resetCooldown(); visibleSystem.clear();
      const st = store.get();
      const before = st.trainer.level;
      MissionSystem.updateObjective(st, 'capturar_cantidad', 'any', 1);
      MissionSystem.updateObjective(st, 'capturar_species', _sp.id, 1);
      MissionSystem.updateObjective(st, 'descubrir_asteria', _sp.id, 1);
      MissionSystem.gainTrainerXp(st, 12);
      if(st.trainer.level > before) notifyLevelup(`¡Subiste a Nv.${st.trainer.level}!`);
      saveLocal(st);
      notify(`¡${_sp.name} capturada!`, 'success');
      refreshHud();
      MissionSystem.refreshMissions(st);
    },
    onFlee: ()=> { encounterSystem.resetCooldown(); notify('Huiste del encuentro', 'info'); },
    onDefeat: ()=> {
      notify('Debilitado... regresas a Villa Aurelia', 'warning');
      const st = store.get();
      for(const inst of [...st.team.asterias, ...st.team.boxed]){
        if(inst.hp<=0){ inst.hp = Math.max(1, Math.floor(inst.maxHp*0.2)); inst.energy = Math.floor(inst.maxEnergy*0.5); inst.status=null; }
      }
      store.setState(st); saveLocal(st);
      changeZone('villa_aurelia', 14, 12, 'south');
    },
    onVictory: ()=> {
      encounterSystem.resetCooldown();
      const st = store.get();
      // marcar entrenador derrotado si era trainer
      const b = (battle as any).battle as any;
      if(b?.isTrainer && b?.trainer){
        const flag = `trainer_${b.trainer.id}_defeated`;
        st.world.flags[flag]=true;
        MissionSystem.updateObjective(st, 'derrotar_entrenador', b.trainer.id, 1);
        MissionSystem.updateObjective(st, 'ganar_combates', 'any', 1);
      } else {
        MissionSystem.updateObjective(st, 'ganar_combates', 'any', 1);
      }
      if(MissionSystem.gainTrainerXp(st, 5)) notifyLevelup(`¡Nv. ${st.trainer.level}!`);
      MissionSystem.refreshMissions(st);
      saveLocal(st);
      notify('¡Victoria!', 'success');
      refreshHud();
    }
  });
  wrap.appendChild(battle.el);

  function resizeCanvas(): void {
    const rect = wrap.getBoundingClientRect();
    let w = Math.floor(rect.width * (Math.min(window.devicePixelRatio||1,2)));
    let h = Math.floor(rect.height * (Math.min(window.devicePixelRatio||1,2)));
    let logicalW = rect.width, logicalH = rect.height;
    if(logicalW < 10 || logicalH < 10){
      logicalW = wrap.clientWidth || 960;
      logicalH = wrap.clientHeight || 640;
      if(logicalW < 10) logicalW = 960;
      if(logicalH < 10) logicalH = 640;
      w = Math.floor(logicalW * Math.min(window.devicePixelRatio||1,2));
      h = Math.floor(logicalH * Math.min(window.devicePixelRatio||1,2));
      requestAnimationFrame(()=> {
        const r2 = wrap.getBoundingClientRect();
        if(r2.width > 10) resizeCanvas();
      });
    }
    const dpr = Math.min(window.devicePixelRatio||1, 2);
    canvas.width=w; canvas.height=h;
    canvas.style.width = logicalW+'px';
    canvas.style.height = logicalH+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
    camera.resize(logicalW, logicalH);
  }
  resizeCanvas();
  requestAnimationFrame(()=> resizeCanvas());
  setTimeout(()=> resizeCanvas(), 150);
  window.addEventListener('resize', resizeCanvas);
  try{ new ResizeObserver(()=> resizeCanvas()).observe(wrap); }catch{}

  touch.querySelectorAll<HTMLButtonElement>('[data-dir]').forEach(btn=>{
    const dir = btn.dataset.dir as string;
    const down=(e:Event)=>{ e.preventDefault(); if(dir==='interact') input.pressInteract(); else input.setDir(dir as any, true); };
    const up=(e:Event)=>{ e.preventDefault(); if(dir!=='interact') input.setDir(dir as any,false); if(dir!=='interact') input.setDir(null,false); };
    btn.addEventListener('touchstart', down,{passive:false}); btn.addEventListener('touchend', up,{passive:false});
    btn.addEventListener('mousedown', down); btn.addEventListener('mouseup', up); btn.addEventListener('mouseleave', up);
  });

  hud.querySelector<HTMLButtonElement>('[data-action="menu"]')!.addEventListener('click',()=> toggleMenu());
  hud.querySelector<HTMLButtonElement>('[data-action="map"]')!.addEventListener('click',()=> toggleMap());
  hud.querySelector<HTMLButtonElement>('[data-action="save"]')!.addEventListener('click',()=> doSave(true));
  hud.querySelector<HTMLButtonElement>('[data-action="exit"]')!.addEventListener('click',()=>{ doSave(false); location.hash='#/title'; });
  mapOverlay.querySelector<HTMLButtonElement>('[data-close-map]')!.addEventListener('click',()=> toggleMap(false));

  function toggleMap(force?:boolean): void {
    if(battle.isVisible()||menuOpen||shopOverlay) return;
    mapOpen = force!==undefined? force : !mapOpen;
    mapOverlay.style.display = mapOpen? 'grid':'none';
    audio.playSfx('menu');
    if(mapOpen) drawAtlas();
  }
  function toggleMenu(force?:boolean): void {
    if(battle.isVisible()||mapOpen||shopOverlay) return;
    if(force===false && menuOverlay){ menuOverlay.remove(); menuOverlay=null; menuOpen=false; return; }
    if(menuOverlay){ menuOverlay.remove(); menuOverlay=null; menuOpen=false; audio.playSfx('menu'); return; }
    menuOpen=true; audio.playSfx('menu');
    // determinar tab según contexto: si tiene misiones disponibles, abrir misiones
    const st = store.get();
    const hasCompletable = st.missions.some(m=> m.status==='completada');
    const initialTab = hasCompletable ? 'misiones' as const : 'perfil' as const;
    menuOverlay = createMenuScreen(initialTab, ()=>{ menuOverlay?.remove(); menuOverlay=null; menuOpen=false; audio.playSfx('menu'); refreshHud(); });
    wrap.appendChild(menuOverlay);
  }
  function openShop(): void {
    if(shopOverlay) return;
    audio.playSfx('menu');
    shopOverlay = createShopScreen(()=>{ shopOverlay?.remove(); shopOverlay=null; audio.playSfx('menu'); refreshHud(); });
    wrap.appendChild(shopOverlay);
  }

  function refreshHud(): void {
    const st = store.get();
    const nucleos = st.inventory.find(i=>i.id==='nucleo_vinculo')?.qty ?? 0;
    nucleoLabel.textContent = `⬢ Núcleos ${nucleos}`;
    teamLabel.textContent = `✦ ${st.team.asterias.length}/${GAME_CONFIG.maxTeamSize} · ${Object.values(st.registry).filter(r=>r.caught).length}/6`;
    aureosLabel.textContent = `💰 ${st.currency} Aurel`;
    trainerLabel.textContent = `Nv.${st.trainer.level} · ${st.trainer.xp}/${st.trainer.xpToNext}`;
  }

  function doSave(showToast=true): void {
    const s=store.get();
    s.world.zoneId=zoneId; s.world.position={x:Math.round(player.x), y:Math.round(player.y)}; s.world.facing=player.facing;
    s.time={tick:time.tick, phase: time.phase as any};
    if(!s.world.discoveredZones.includes(zoneId)) s.world.discoveredZones=[...s.world.discoveredZones, zoneId];
    // sync currency
    s.currency = s.trainer.aureos;
    store.setState(s); saveLocal(s);
    if(showToast) notify('Progreso guardado · '+zone.label, 'info');
    fetch('/api/save',{method:'POST', headers:{'content-type':'application/json'}, body: JSON.stringify({zoneId, pos:s.world.position, team:s.team.asterias.length, currency:s.currency, trainerLevel:s.trainer.level})}).catch(()=>{});
    refreshHud();
  }

  function findNearbyInteractable(): void {
    nearbyNpc=null; nearbySign=null; nearbyVisible=null; nearbyHidden=null;
    const checks = [
      {x:Math.round(player.x), y:Math.round(player.y)},
      {x:Math.round(player.x)+(player.facing==='east'?1:player.facing==='west'?-1:0), y:Math.round(player.y)+(player.facing==='south'?1:player.facing==='north'?-1:0)}
    ];
    // hidden objects primero (prioridad)
    const hiddenHere = objectsInZone(zoneId).filter(o=> !store.get().collectedObjects.includes(o.id) || o.respawn);
    for(const c of checks){
      const hid = hiddenHere.find(h=> h.x===c.x && h.y===c.y);
      if(hid){ nearbyHidden=hid.id; break; }
    }
    for(const c of checks){
      const npc = npcs.find(n=> n.x===c.x && n.y===c.y);
      if(npc){ nearbyNpc=npc; break; }
      const sign = zone.signs.find(s=> s.x===c.x && s.y===c.y);
      if(sign){ nearbySign=sign as any; break; }
      const vis = visibleSystem.getAll().find(v=> v.x===c.x && v.y===c.y);
      if(vis){ nearbyVisible=vis.id; break; }
    }
    if(!nearbyNpc && !nearbySign && !nearbyVisible && !nearbyHidden){
      for(const n of npcs){
        const dx=Math.abs(n.x-player.x), dy=Math.abs(n.y-player.y);
        if((dx===1&&dy===0)||(dx===0&&dy===1)||(dx===0&&dy===0)){ nearbyNpc=n; break; }
      }
      if(!nearbyNpc){
        for(const v of visibleSystem.getAll()){
          const dx=Math.abs(v.x-player.x), dy=Math.abs(v.y-player.y);
          if((dx<=1&&dy<=1)){ nearbyVisible=v.id; break; }
        }
      }
      if(!nearbyNpc && !nearbyVisible){
        const hid2 = hiddenHere.find(h=> Math.abs(h.x-player.x)<=1 && Math.abs(h.y-player.y)<=1);
        if(hid2) nearbyHidden=hid2.id;
      }
    }
  }

  function startDialogueForNpc(npc:NPCDef): void {
    // NPCs especiales Fase 5
    if(npc.id==='liora' && zoneId==='tienda_aurelia'){
      openShop(); return;
    }
    if(npc.id==='solea' && zoneId==='centro_aurelia'){
      // curar equipo
      const st = store.get();
      let healed=0;
      for(const inst of [...st.team.asterias, ...st.team.boxed]){
        if(inst.hp < inst.maxHp){ inst.hp = inst.maxHp; inst.energy = inst.maxEnergy; inst.status=null; inst.statStages={atk:0,def:0,spd:0,acc:0}; healed++; }
      }
      store.setState(st); saveLocal(st);
      dialogue.start([{ speaker:'Solea', lines:[`¡Bienvenido! He restaurado a ${healed} Asterias.`, `Tu equipo está como nuevo. ¡Vuelve cuando necesites descanso!`] }]);
      dialogueEl.style.display='block';
      audio.playSfx('interact');
      MissionSystem.updateObjective(st, 'hablar_npc', 'solea', 1);
      return;
    }
    // misiones: hablar con npc puede avanzar
    const stTalk = store.get();
    const beforeMissions = JSON.stringify(stTalk.missions);
    // si es alba y tiene carta, dar carta
    if(npc.id==='alba'){
      const hasCarta = stTalk.inventory.find(i=> i.id==='carta_aurelia');
      const mission = stTalk.missions.find(m=> m.id==='ayuda_investigador');
      if(mission?.status==='activa' && !hasCarta){
        // dar carta al hablar
        const defItem = getItem('carta_aurelia');
        if(defItem){
          addItem(stTalk, 'carta_aurelia', 1);
          notify('¡Recibiste Carta de Aurelia!', 'item');
          MissionSystem.updateObjective(stTalk, 'hablar_npc', 'alba', 1);
          MissionSystem.updateObjective(stTalk, 'conseguir_item', 'carta_aurelia', 1);
        }
      } else {
        MissionSystem.updateObjective(stTalk, 'hablar_npc', npc.id, 1);
      }
    } else {
      MissionSystem.updateObjective(stTalk, 'hablar_npc', npc.id, 1);
    }
    if(JSON.stringify(stTalk.missions)!== beforeMissions) saveLocal(stTalk);

    const key=`npc_${npc.id}_talks`;
    const talks=(store.get().world.flags[key] as number)??0;
    dialogue.start([{speaker:npc.name, lines: npc.dialogues[talks % npc.dialogues.length]}]);
    dialogueEl.style.display='block';
    const s=store.get(); s.world.flags[key]=talks+1; store.setState(s);
    saveLocal(s);
    audio.playSfx('interact');
    // si es inicio de misión, ofrecer iniciar
    const missionForNpc = MISSIONS.find(m=> m.giverNpcId===npc.id);
    if(missionForNpc){
      const ms = s.missions.find(m=> m.id===missionForNpc.id);
      if(ms?.status==='disponible'){
        setTimeout(()=>{
          if(confirm(`¿Aceptar misión "${missionForNpc.name}"?\n\n${missionForNpc.description}`)){
            const st2=store.get();
            MissionSystem.startMission(st2, missionForNpc.id);
            notifyMission(`¡Misión aceptada: ${missionForNpc.name}!`);
          }
        }, 600);
      } else if(ms?.status==='completada'){
        setTimeout(()=>{
          if(confirm(`¿Entregar misión "${missionForNpc.name}" y reclamar recompensa?`)){
            const st2=store.get();
            if(MissionSystem.claimReward(st2, missionForNpc.id)){
              notify('¡Misión entregada!', 'success');
              refreshHud();
            }
          }
        }, 600);
      }
    }
  }
  function startDialogueForSign(sign:{text:string[]}): void {
    const title=sign.text[0]??'Cartel'; const body=sign.text.slice(1);
    dialogue.start([{speaker:title, lines: body.length? body : [title]}]);
    dialogueEl.style.display='block'; audio.playSfx('interact');
  }
  function collectHidden(id:string): void {
    const obj = objectsInZone(zoneId).find(o=> o.id===id);
    if(!obj) return;
    const st = store.get();
    if(!obj.respawn && st.collectedObjects.includes(id)){
      notify('Ya recogiste este objeto', 'info');
      return;
    }
    // añadir item
    addItem(st, obj.itemId, obj.qty);
    if(!obj.respawn) st.collectedObjects.push(id);
    st.stats.objectsCollected = (st.stats.objectsCollected||0)+1;
    store.setState(st); saveLocal(st);
    const def = getItem(obj.itemId);
    notifyItem(`¡Encontraste ${def?.name ?? obj.itemId} ×${obj.qty}!`);
    MissionSystem.updateObjective(st, 'recoger_objeto', obj.itemId, obj.qty);
    MissionSystem.updateObjective(st, 'conseguir_item', obj.itemId, obj.qty);
    // si es fragmento_geoda, también para misión
    if(obj.itemId==='fragmento_geoda'){
      MissionSystem.updateObjective(st, 'conseguir_item', 'fragmento_geoda', 1);
    }
    refreshHud();
    // ocultar prompt
    findNearbyInteractable();
  }

  function tryInteract(): void {
    if(dialogue.isActive()){
      dialogue.advance();
      if(!dialogue.isActive()){ dialogueEl.style.display='none'; audio.playSfx('dialog'); }
      else audio.playSfx('dialog');
      return;
    }
    if(shopOverlay) return;
    if(menuOpen) return;
    if(nearbyHidden){
      collectHidden(nearbyHidden);
      audio.playSfx('interact');
      return;
    }
    if(nearbyVisible){
      const vis = visibleSystem.getAll().find(v=> v.id===nearbyVisible);
      if(vis){
        battle.startWild(vis.speciesId, vis.level, time.phase as any);
        visibleSystem.remove(vis.id);
        audio.playSfx('interact');
        // misiones descubrir
        const st=store.get();
        MissionSystem.updateObjective(st, 'descubrir_asteria', vis.speciesId, 1);
        return;
      }
    }
    if(nearbyNpc){
      const trainer = TRAINERS.find(t=> t.zone===zoneId && Math.abs(t.x - nearbyNpc!.x)<=1 && Math.abs(t.y - nearbyNpc!.y)<=1);
      if(trainer){
        const flag = `trainer_${trainer.id}_defeated`;
        if(store.get().world.flags[flag]){
          startDialogueForNpc(nearbyNpc);
          return;
        }
        battle.startTrainer(trainer.id);
        audio.playSfx('interact');
        return;
      }
      startDialogueForNpc(nearbyNpc); return;
    }
    if(nearbySign){ startDialogueForSign(nearbySign); return; }
  }

  function changeZone(to:ZoneId,toX:number,toY:number,facing?: typeof player.facing): void {
    if(transitioning) return;
    transitioning=true; fade.style.opacity='1'; audio.playSfx('warp');
    window.setTimeout(()=>{
      const prevZone = zoneId;
      zoneId=to; zone=getZone(zoneId); npcs=npcsInZone(zoneId);
      player.x=toX; player.y=toY; if(facing) player.facing=facing;
      lastTileX=Math.round(player.x); lastTileY=Math.round(player.y);
      visibleSystem.clear();
      camera.snap({x:player.x*GAME_CONFIG.tileSize, y:player.y*GAME_CONFIG.tileSize}, {w:zone.size.w*GAME_CONFIG.tileSize, h:zone.size.h*GAME_CONFIG.tileSize});
      audio.playMusic(zone.musicKey as any);
      doSave(false);
      const s=store.get();
      if(!s.world.discoveredZones.includes(zoneId)){ s.world.discoveredZones=[...s.world.discoveredZones, zoneId]; store.setState(s); }
      // misiones visitar_zona
      MissionSystem.updateObjective(s, 'visitar_zona', zoneId, 1);
      if(to==='ruta_aurelia' && prevZone==='villa_aurelia'){
        MissionSystem.updateObjective(s, 'visitar_zona', 'ruta_aurelia', 1);
        MissionSystem.updateObjective(s, 'visitar_zona', 'ruta_arbol_madre', 0); // se completa al llegar al árbol (separado)
        // check árbol madre
        if(Math.abs(toX-10)<=2 && Math.abs(toY-19)<=2){
          MissionSystem.updateObjective(s, 'visitar_zona', 'ruta_arbol_madre', 1);
        }
      }
      // también check si es árbol madre directo
      if(zoneId==='ruta_aurelia' && Math.abs(player.x-10)<=1 && Math.abs(player.y-19)<=1){
        MissionSystem.updateObjective(s, 'visitar_zona', 'ruta_arbol_madre', 1);
      }
      MissionSystem.refreshMissions(s);
      saveLocal(s);
      zoneLabel.textContent=zone.label+(zone.outside?' · Exterior':' · Interior');
      transitioning=false; fade.style.opacity='0'; notify('→ '+zone.label, 'info'); refreshHud();
    },380);
  }

  function handleTileEnter(newX:number,newY:number): void {
    if(battle.isVisible()||mapOpen||menuOpen||dialogue.isActive()||shopOverlay) return;
    if(zoneId!=='ruta_aurelia') return;
    // check árbol madre para misión
    if(newX===10 && newY===19){
      const st=store.get();
      MissionSystem.updateObjective(st, 'visitar_zona', 'ruta_arbol_madre', 1);
    }
    const tile = zone.map[newY]?.[newX];
    if(tile===12){
      const enc = encounterSystem.checkTallgrass(zoneId, time.phase as any, tile);
      if(enc){
        battle.startWild(enc.species.id, enc.level, time.phase as any);
        audio.playSfx('interact');
        const st2=store.get();
        MissionSystem.updateObjective(st2, 'descubrir_asteria', enc.species.id, 1);
      }
    }
  }

  function update(dt:number): void {
    input.update();
    if(input.state.mapPressed) toggleMap();
    // T para menú, E para interactuar ya manejado
    // @ts-ignore
    if(input['keys']?.has('t') && !(input as any)._prevT){
      (input as any)._prevT = true;
      toggleMenu();
    } else if(!(input['keys']?.has('t'))) (input as any)._prevT = false;
    // shop con B? no, solo via NPC
    if(mapOpen){
      if(input.state.escape) toggleMap(false);
      return;
    }
    if(menuOpen){
      if(input.state.escape){ toggleMenu(false); }
      return;
    }
    if(shopOverlay){
      if(input.state.escape){ shopOverlay.remove(); shopOverlay=null; audio.playSfx('menu'); }
      return;
    }
    if(battle.isVisible()) return;

    if(dialogue.isActive()){
      dialogue.tickTypewriter(dt);
      dlgName.textContent=dialogue.getSpeaker();
      dlgText.textContent=dialogue.getVisibleText();
      if(input.state.interactPressed) tryInteract();
      if(input.state.escape){ dialogue.close(); dialogueEl.style.display='none'; }
      return;
    }
    if(input.state.interactPressed){
      findNearbyInteractable();
      if(nearbyHidden||nearbyNpc||nearbySign||nearbyVisible){ tryInteract(); return; }
    }

    const speed=4.6; let dx=0,dy=0;
    if(input.state.up) dy-=1; if(input.state.down) dy+=1; if(input.state.left) dx-=1; if(input.state.right) dx+=1;
    if(dx!==0||dy!==0){
      if(dx!==0&&dy!==0){ dx*=0.7071; dy*=0.7071; }
      if(Math.abs(dx)>Math.abs(dy)) player.facing= dx>0?'east':'west';
      else if(dy!==0) player.facing= dy>0?'south':'north';
      player.moving=true; player.animTick+=dt*9;
      const step=speed*dt; let nx=player.x+dx*step, ny=player.y+dy*step;
      if(canMoveTo(zone.map, Math.round(nx+0.5-0.5+(dx>0?0.4:-0.4)), Math.round(player.y), npcs.map(n=>({x:n.x,y:n.y})) ) || canMoveTo(zone.map, Math.round(nx), Math.round(player.y), npcs.map(n=>({x:n.x,y:n.y}))) ){
        player.x=Math.max(0.5, Math.min(zone.size.w-0.5, nx));
      }
      if(canMoveTo(zone.map, Math.round(player.x), Math.round(ny+0.5-0.5+(dy>0?0.4:-0.4)), npcs.map(n=>({x:n.x,y:n.y}))) || canMoveTo(zone.map, Math.round(player.x), Math.round(ny), npcs.map(n=>({x:n.x,y:n.y}))) ){
        player.y=Math.max(0.5, Math.min(zone.size.h-0.5, ny));
      }
      player.x=Math.max(0, Math.min(zone.size.w-0.01, player.x));
      player.y=Math.max(0, Math.min(zone.size.h-0.01, player.y));
    } else player.moving=false;

    const curTX=Math.round(player.x), curTY=Math.round(player.y);
    if(curTX!==lastTileX || curTY!==lastTileY){
      handleTileEnter(curTX,curTY);
      lastTileX=curTX; lastTileY=curTY;
    }
    const ix=Math.round(player.x), iy=Math.round(player.y);
    const warp=zone.warps.find(w=> w.x===ix && w.y===iy);
    if(warp) changeZone(warp.to, warp.toX, warp.toY, warp.facing);

    visibleSystem.update(dt, zoneId, time.phase as any, zone.map, npcs.map(n=>({x:n.x,y:n.y})), {x:player.x,y:player.y});
    const touched = visibleSystem.getAll().find(v=> v.x===Math.round(player.x) && v.y===Math.round(player.y));
    if(touched && !battle.isVisible()){
      battle.startWild(touched.speciesId, touched.level, time.phase as any);
      visibleSystem.remove(touched.id);
      audio.playSfx('interact');
      const st=store.get();
      MissionSystem.updateObjective(st, 'descubrir_asteria', touched.speciesId, 1);
    }

    findNearbyInteractable();
    if(nearbyHidden){
      const obj = objectsInZone(zoneId).find(o=> o.id===nearbyHidden);
      const def = obj? getItem(obj.itemId) : null;
      prompt.innerHTML=`<span style="font-family:var(--font-mono);font-size:.72rem;letter-spacing:.12em;text-transform:uppercase;background:rgba(255,207,107,.92);color:#1a1200;border:1px solid rgba(255,207,107,.9);padding:.35rem .6rem;border-radius:999px">✦ ${def?.name ?? 'Objeto'} [ESPACIO]</span>`;
    } else if(nearbyVisible) prompt.innerHTML=`<span style="font-family:var(--font-mono);font-size:.72rem;letter-spacing:.12em;text-transform:uppercase;background:rgba(124,240,255,.18);color:#fff;border:1px solid rgba(255,207,107,.7);padding:.35rem .6rem;border-radius:999px">⬢ ${getSpecies(visibleSystem.getAll().find(v=>v.id===nearbyVisible!)?.speciesId ?? '')?.name ?? 'Asteria'} [ESPACIO]</span>`;
    else if(nearbyNpc||nearbySign) prompt.innerHTML=`<span style="font-family:var(--font-mono);font-size:.72rem;letter-spacing:.12em;text-transform:uppercase;background:rgba(0,0,0,.78);color:#fff;border:1px solid rgba(124,240,255,.5);padding:.35rem .6rem;border-radius:999px">[ ESPACIO ] hablar</span>`;
    prompt.style.display=(nearbyNpc||nearbySign||nearbyVisible||nearbyHidden) && !dialogue.isActive() ? 'block':'none';

    time.update(dt); timeAcc+=dt;
    if(timeAcc>0.5){ timeAcc=0; timeLabel.textContent=time.getLabel(); }

    camera.follow({x:player.x*GAME_CONFIG.tileSize, y:player.y*GAME_CONFIG.tileSize}, {w:zone.size.w*GAME_CONFIG.tileSize, h:zone.size.h*GAME_CONFIG.tileSize});

    saveAcc+=dt;
    if(saveAcc>2){
      saveAcc=0;
      const s=store.get();
      s.stats.stepsWalked += player.moving?1:0;
      s.stats.playtimeSeconds+=2;
      s.world.position={x:Math.round(player.x), y:Math.round(player.y)};
      s.world.zoneId=zoneId; s.world.facing=player.facing;
      store.setState(s); saveLocal(s); refreshHud();
    }
    zoneLabel.textContent=zone.label+(zone.outside?' · Exterior':' · Interior');
    posLabel.textContent=`(${Math.round(player.x)}, ${Math.round(player.y)})`;
    refreshHud();
  }

  function drawTile(ctx:CanvasRenderingContext2D,tileId:number,sx:number,sy:number,size:number,tx:number=0,ty:number=0,timeTick:number=0): void {
    const def=TILE_DEFS[tileId] ?? TILE_DEFS[0];
    ctx.fillStyle=def.color; ctx.fillRect(sx,sy,size,size);
    ctx.save(); ctx.translate(sx,sy); const s=size;
    switch(def.kind){
      case 'path':
        ctx.fillStyle='rgba(255,255,255,.08)'; ctx.fillRect(0,0,s,2); ctx.fillRect(0,s-2,s,2);
        ctx.fillStyle='rgba(0,0,0,.08)'; ctx.fillRect(s*0.2,s*0.48,s*0.6,2); break;
      case 'plaza':
        ctx.strokeStyle='rgba(0,0,0,.08)'; ctx.lineWidth=1; ctx.strokeRect(4,4,s-8,s-8);
        ctx.fillStyle='rgba(106,92,255,.06)'; ctx.fillRect(s*0.35,s*0.35,s*0.3,s*0.3); break;
      case 'water': case 'water_deep':{
        ctx.fillStyle=def.kind==='water_deep'?'#0f4a7a':'#1e6fa8'; ctx.fillRect(0,0,s,s);
        ctx.strokeStyle='rgba(255,255,255,.18)'; ctx.lineWidth=1;
        const off=(timeTick*20 + tx*0.7 + ty*0.5)%s;
        ctx.beginPath(); ctx.moveTo(-off,s*0.35); ctx.lineTo(s-off,s*0.35); ctx.moveTo(s-off,s*0.65); ctx.lineTo(2*s-off,s*0.65); ctx.stroke(); break;
      }
      case 'tree':{
        ctx.fillStyle='#3e2f1e'; ctx.fillRect(s*0.42,s*0.55,s*0.16,s*0.45);
        ctx.fillStyle='#1b5e2f'; ctx.beginPath(); ctx.arc(s*0.5,s*0.32,s*0.34,0,Math.PI*2); ctx.fill();
        ctx.fillStyle='#2a7a3a'; ctx.beginPath(); ctx.arc(s*0.38,s*0.38,s*0.18,0,Math.PI*2); ctx.fill();
        ctx.fillStyle='#144a22'; ctx.beginPath(); ctx.arc(s*0.62,s*0.42,s*0.14,0,Math.PI*2); ctx.fill(); break;
      }
      case 'tree2':{
        ctx.fillStyle='#2a1f0f'; ctx.fillRect(s*0.4,s*0.5,s*0.2,s*0.5);
        ctx.fillStyle='#0f3a1f'; ctx.beginPath(); ctx.arc(s*0.5,s*0.3,s*0.38,0,Math.PI*2); ctx.fill();
        ctx.fillStyle='#1e5a2e'; ctx.beginPath(); ctx.arc(s*0.5,s*0.22,s*0.22,0,Math.PI*2); ctx.fill(); break;
      }
      case 'wall':{
        ctx.fillStyle='#2a2f4a'; ctx.fillRect(0,0,s,s);
        ctx.fillStyle='#3a4060'; ctx.fillRect(2,2,s-4,s*0.5);
        ctx.fillStyle='rgba(0,0,0,.2)'; ctx.fillRect(0,s*0.75,s,s*0.25);
        ctx.strokeStyle='rgba(255,255,255,.06)'; ctx.strokeRect(0.5,0.5,s-1,s-1); break;
      }
      case 'house_floor':{
        ctx.fillStyle='#d8c9a8'; ctx.fillRect(0,0,s,s);
        ctx.strokeStyle='rgba(0,0,0,.06)'; ctx.strokeRect(0,0,s,s);
        ctx.fillStyle='rgba(0,0,0,.04)'; ctx.fillRect(s*0.1,s*0.1,s*0.8,s*0.8); break;
      }
      case 'door':{
        ctx.fillStyle='#8b5a2b'; ctx.fillRect(s*0.15,s*0.05,s*0.7,s*0.95);
        ctx.fillStyle='#6b4020'; ctx.fillRect(s*0.15,s*0.05,s*0.12,s*0.95);
        ctx.fillStyle='#ffd27a'; ctx.beginPath(); ctx.arc(s*0.72,s*0.5,3,0,Math.PI*2); ctx.fill();
        ctx.strokeStyle='rgba(255,255,255,.2)'; ctx.strokeRect(s*0.15,s*0.05,s*0.7,s*0.95); break;
      }
      case 'fence':{
        ctx.fillStyle='#6b4a2a'; ctx.fillRect(0,s*0.32,s,s*0.36);
        ctx.fillStyle='#8b6a3a'; for(let i=0;i<3;i++) ctx.fillRect(4+i*s*0.32,4,6,s-8); break;
      }
      case 'flower':{
        ctx.fillStyle='#2a5a3a'; ctx.fillRect(0,0,s,s);
        ctx.fillStyle='#ff6b9d'; ctx.beginPath(); ctx.arc(s*0.3,s*0.35,4,0,Math.PI*2); ctx.fill();
        ctx.fillStyle='#ffcf6b'; ctx.beginPath(); ctx.arc(s*0.7,s*0.45,3.5,0,Math.PI*2); ctx.fill();
        ctx.fillStyle='#7cf0ff'; ctx.beginPath(); ctx.arc(s*0.5,s*0.7,3,0,Math.PI*2); ctx.fill(); break;
      }
      case 'rock':{
        ctx.fillStyle='#4a5560'; ctx.beginPath(); ctx.ellipse(s*0.5,s*0.6,s*0.32,s*0.22,0,0,Math.PI*2); ctx.fill();
        ctx.fillStyle='#6b7a8a'; ctx.beginPath(); ctx.ellipse(s*0.42,s*0.52,s*0.14,s*0.1,0,0,Math.PI*2); ctx.fill(); break;
      }
      case 'tallgrass':{
        ctx.fillStyle='#264a2e'; ctx.fillRect(0,0,s,s);
        ctx.strokeStyle='#3a6a3e'; ctx.lineWidth=1.2;
        for(let i=0;i<4;i++){ const x=6+i*7; ctx.beginPath(); ctx.moveTo(x,s); ctx.lineTo(x+s*0.08,s*0.45); ctx.stroke(); }
        break;
      }
      case 'bridge':{
        ctx.fillStyle='#b8a07a'; ctx.fillRect(0,0,s,s);
        ctx.fillStyle='#8b6a3a'; for(let i=0;i<s;i+=8) ctx.fillRect(0,i,s,2);
        ctx.strokeStyle='rgba(0,0,0,.15)'; ctx.strokeRect(0,0,s,s); break;
      }
      case 'grass': default:{
        const v=(tx*12+ty*7)%10;
        if(v<2){ ctx.fillStyle='rgba(255,255,255,.04)'; ctx.fillRect(4,4,s-8,s-8); }
        if(v===5){ ctx.fillStyle='rgba(0,0,0,.06)'; ctx.fillRect(s*0.2,s*0.2,3,3); }
        break;
      }
    }
    ctx.restore();
  }

  function drawNPC(ctx:CanvasRenderingContext2D,npc:NPCDef,px:number,py:number,size:number): void {
    const s=size;
    ctx.save(); ctx.translate(px,py);
    ctx.fillStyle='rgba(255,255,255,.95)'; ctx.beginPath(); ctx.roundRect(s*0.10,-12,s*0.80,14,4); ctx.fill();
    ctx.fillStyle='rgba(0,0,0,.32)'; ctx.beginPath(); ctx.ellipse(s*0.5,s*0.92,s*0.30,s*0.13,0,0,Math.PI*2); ctx.fill();
    ctx.fillStyle=npc.color; ctx.strokeStyle='#fff'; ctx.lineWidth=1.8;
    ctx.fillRect(s*0.24,s*0.38,s*0.52,s*0.46); ctx.strokeRect(s*0.24,s*0.38,s*0.52,s*0.46);
    ctx.fillStyle='#f5d6b8'; ctx.beginPath(); ctx.arc(s*0.5,s*0.28,s*0.20,0,Math.PI*2); ctx.fill(); ctx.strokeStyle='#fff'; ctx.lineWidth=1.2; ctx.stroke();
    ctx.fillStyle=npc.accent; ctx.beginPath(); ctx.arc(s*0.5,s*0.10,s*0.14,0,Math.PI*2); ctx.fill();
    const fx=npc.facing==='east'?2:npc.facing==='west'?-2:0, fy=npc.facing==='south'?2:npc.facing==='north'?-1:0;
    ctx.fillStyle='#1a1a1a'; ctx.beginPath(); ctx.arc(s*0.42+fx*0.02,s*0.28+fy*0.02,2,0,Math.PI*2); ctx.arc(s*0.58+fx*0.02,s*0.28+fy*0.02,2,0,Math.PI*2); ctx.fill();
    ctx.fillStyle='rgba(0,0,0,.85)'; ctx.fillRect(s*0.06,-10,s*0.88,10);
    ctx.fillStyle='#fff'; ctx.font=`700 7px Inter, sans-serif`; ctx.textAlign='center'; ctx.fillText(npc.name,s*0.5,-2);
    ctx.restore();
  }

  function drawVisibleAsteria(ctx:CanvasRenderingContext2D, sp: import('../entities/asteria.js').AsteriaSpecies, px:number,py:number,size:number, facing:string): void {
    const s=size;
    ctx.save(); ctx.translate(px,py);
    ctx.fillStyle='rgba(255,255,255,.92)'; ctx.beginPath(); ctx.ellipse(s*0.5,s*0.50,s*0.38,s*0.40,0,0,Math.PI*2); ctx.fill();
    ctx.fillStyle='rgba(0,0,0,.22)'; ctx.beginPath(); ctx.ellipse(s*0.5,s*0.92,s*0.24,s*0.10,0,0,Math.PI*2); ctx.fill();
    ctx.fillStyle=sp.color; ctx.strokeStyle='#fff'; ctx.lineWidth=1.6;
    if(sp.silhouette==='hoja'){
      ctx.beginPath(); ctx.ellipse(s*0.5,s*0.5, s*0.28, s*0.22,0,0,Math.PI*2); ctx.fill(); ctx.stroke();
      ctx.fillStyle='#fff'; ctx.beginPath(); ctx.arc(s*0.5,s*0.42,2.5,0,Math.PI*2); ctx.fill();
    } else if(sp.silhouette==='chispa'){
      ctx.beginPath(); ctx.arc(s*0.5,s*0.5, s*0.22,0,Math.PI*2); ctx.fill(); ctx.stroke();
      ctx.strokeStyle=sp.accent; ctx.beginPath(); ctx.arc(s*0.5,s*0.5, s*0.30,0,Math.PI*1.4); ctx.stroke();
    } else if(sp.silhouette==='ajolote'){
      ctx.beginPath(); ctx.ellipse(s*0.5,s*0.55, s*0.24, s*0.16,0,0,Math.PI*2); ctx.fill(); ctx.stroke();
      ctx.fillStyle=sp.accent; ctx.beginPath(); ctx.arc(s*0.5,s*0.32,5,0,Math.PI*2); ctx.fill();
    } else if(sp.silhouette==='draco'){
      ctx.beginPath(); ctx.ellipse(s*0.5,s*0.52, s*0.26, s*0.18,0,0,Math.PI*2); ctx.fill(); ctx.stroke();
      ctx.fillStyle='#ffcf6b'; ctx.beginPath(); ctx.arc(s*0.5,s*0.38,2,0,Math.PI*2); ctx.fill();
    } else if(sp.silhouette==='polilla'){
      ctx.fillStyle=sp.color; ctx.beginPath(); ctx.ellipse(s*0.32,s*0.5, s*0.18, s*0.12, -0.2,0,Math.PI*2); ctx.fill();
      ctx.beginPath(); ctx.ellipse(s*0.68,s*0.5, s*0.18, s*0.12, 0.2,0,Math.PI*2); ctx.fill();
      ctx.fillStyle='#111'; ctx.beginPath(); ctx.ellipse(s*0.5,s*0.54, s*0.09, s*0.14,0,0,Math.PI*2); ctx.fill();
    } else {
      ctx.beginPath(); ctx.moveTo(s*0.5,s*0.22); ctx.lineTo(s*0.78,s*0.68); ctx.lineTo(s*0.22,s*0.68); ctx.closePath(); ctx.fill(); ctx.stroke();
      ctx.fillStyle=sp.accent; ctx.beginPath(); ctx.moveTo(s*0.5,s*0.38); ctx.lineTo(s*0.60,s*0.58); ctx.lineTo(s*0.40,s*0.58); ctx.closePath(); ctx.fill();
    }
    ctx.fillStyle='rgba(255,255,255,.9)'; ctx.beginPath(); ctx.arc(s*0.62,s*0.32,1.2,0,Math.PI*2); ctx.fill();
    ctx.fillStyle='rgba(0,0,0,.55)'; ctx.fillRect(s*0.12, -6, s*0.76, 8);
    ctx.fillStyle='#fff'; ctx.font=`600 6px Inter`; ctx.textAlign='center'; ctx.fillText(sp.name, s*0.5, -1);
    ctx.restore();
  }

  function drawPlayer(ctx:CanvasRenderingContext2D,px:number,py:number,size:number,facing:string,moving:boolean,tick:number): void {
    const s=size, bob=moving? Math.sin(tick*1.2)*2 : 0;
    ctx.save(); ctx.translate(px,py+bob);
    ctx.fillStyle='rgba(255,255,255,.95)'; ctx.beginPath(); ctx.ellipse(s*0.5,s*0.50,s*0.42,s*0.46,0,0,Math.PI*2); ctx.fill();
    ctx.fillStyle='rgba(0,0,0,.35)'; ctx.beginPath(); ctx.ellipse(s*0.5,s*0.92,s*0.30,s*0.12,0,0,Math.PI*2); ctx.fill();
    ctx.fillStyle='#6a5cff'; ctx.strokeStyle='#fff'; ctx.lineWidth=1.8;
    ctx.fillRect(s*0.20,s*0.36,s*0.60,s*0.50); ctx.strokeRect(s*0.20,s*0.36,s*0.60,s*0.50);
    ctx.fillStyle='#7cf0ff'; ctx.fillRect(s*0.20,s*0.36,s*0.60,7);
    ctx.fillStyle='#f8d8b8'; ctx.beginPath(); ctx.arc(s*0.5,s*0.28,s*0.21,0,Math.PI*2); ctx.fill(); ctx.strokeStyle='#fff'; ctx.lineWidth=1.4; ctx.stroke();
    ctx.fillStyle='#1a1a2e'; ctx.beginPath(); ctx.arc(s*0.5,s*0.18,s*0.17,Math.PI,0); ctx.fill();
    const ox=facing==='east'?3:facing==='west'?-3:0, oy=facing==='south'?2:facing==='north'?-2:0;
    ctx.fillStyle='#0b1020'; ctx.beginPath(); ctx.arc(s*0.41+ox*0.15,s*0.28+oy*0.08,2.2,0,Math.PI*2); ctx.arc(s*0.59+ox*0.15,s*0.28+oy*0.08,2.2,0,Math.PI*2); ctx.fill();
    ctx.fillStyle='#fff'; ctx.beginPath(); ctx.arc(s*0.42+ox*0.15,s*0.27+oy*0.08,0.8,0,Math.PI*2); ctx.arc(s*0.60+ox*0.15,s*0.27+oy*0.08,0.8,0,Math.PI*2); ctx.fill();
    ctx.fillStyle='#ffcf6b'; ctx.beginPath();
    if(facing==='north') ctx.moveTo(s*0.5,s*0.02), ctx.lineTo(s*0.44,s*0.10), ctx.lineTo(s*0.56,s*0.10);
    else if(facing==='south') ctx.moveTo(s*0.5,s*0.88), ctx.lineTo(s*0.44,s*0.80), ctx.lineTo(s*0.56,s*0.80);
    else if(facing==='east') ctx.moveTo(s*0.88,s*0.50), ctx.lineTo(s*0.80,s*0.44), ctx.lineTo(s*0.80,s*0.56);
    else ctx.moveTo(s*0.12,s*0.50), ctx.lineTo(s*0.20,s*0.44), ctx.lineTo(s*0.20,s*0.56);
    ctx.closePath(); ctx.fill();
    ctx.restore();
  }

  function render(): void {
    const dpr = Math.min(window.devicePixelRatio||1, 2);
    const w = wrap.clientWidth, h = wrap.clientHeight;
    ctx.setTransform(dpr,0,0,dpr,0,0);
    ctx.clearRect(0,0,w,h);
    const tile=GAME_CONFIG.tileSize;
    ctx.fillStyle='#0b1020'; ctx.fillRect(0,0,w,h);
    const startX=Math.floor(camera.x/tile), endX=Math.ceil((camera.x+w)/tile);
    const startY=Math.floor(camera.y/tile), endY=Math.ceil((camera.y+h)/tile);
    for(let y=startY; y<endY; y++) for(let x=startX; x<endX; x++){
      if(y<0||y>=zone.size.h||x<0||x>=zone.size.w) continue;
      const tid=zone.map[y][x];
      const sx=Math.floor(x*tile-camera.x), sy=Math.floor(y*tile-camera.y);
      // @ts-ignore
      drawTile(ctx,tid,sx,sy,tile,x,y,time.tick);
    }
    // objetos ocultos (brillo)
    for(const obj of objectsInZone(zoneId)){
      if(store.get().collectedObjects.includes(obj.id) && !obj.respawn) continue;
      const sx=Math.floor(obj.x*tile-camera.x), sy=Math.floor(obj.y*tile-camera.y);
      if(sx<-tile||sx>w||sy<-tile||sy>h) continue;
      // brillo amarillo pulsante
      const pulse = 0.6 + Math.sin(performance.now()*0.004 + obj.x*0.7)*0.4;
      ctx.globalAlpha = pulse;
      ctx.fillStyle='#ffcf6b'; ctx.beginPath(); ctx.arc(sx+tile*0.5, sy+tile*0.5, 5,0,Math.PI*2); ctx.fill();
      ctx.strokeStyle='#fff'; ctx.lineWidth=1.2; ctx.stroke();
      ctx.globalAlpha = 1;
      ctx.fillStyle='rgba(0,0,0,.55)'; ctx.fillRect(sx+tile*0.2, sy-8, tile*0.6, 8);
      ctx.fillStyle='#fff'; ctx.font='600 6px Inter'; ctx.textAlign='center'; ctx.fillText('✦', sx+tile*0.5, sy-2);
    }
    for(const sgn of zone.signs){
      const sx=Math.floor(sgn.x*tile-camera.x), sy=Math.floor(sgn.y*tile-camera.y);
      if(sx<-tile||sx>w||sy<-tile||sy>h) continue;
      ctx.fillStyle='rgba(255,207,107,.95)'; ctx.fillRect(sx+tile*0.65,sy+tile*0.1,8,10);
      ctx.fillStyle='#6b4a2a'; ctx.fillRect(sx+tile*0.68,sy+tile*0.5,2,6);
    }
    for(const npc of npcs){
      const sx=Math.floor(npc.x*tile-camera.x), sy=Math.floor(npc.y*tile-camera.y);
      if(sx<-tile||sx>w||sy<-tile||sy>h) continue;
      drawNPC(ctx,npc,sx,sy,tile);
    }
    for(const vis of visibleSystem.getAll()){
      const sp=getSpecies(vis.speciesId); if(!sp) continue;
      const sx=Math.floor(vis.x*tile-camera.x), sy=Math.floor(vis.y*tile-camera.y);
      if(sx<-tile||sx>w||sy<-tile||sy>h) continue;
      drawVisibleAsteria(ctx,sp,sx,sy,tile,vis.facing);
    }
    const px=Math.floor(player.x*tile-camera.x), py=Math.floor(player.y*tile-camera.y);
    drawPlayer(ctx,px,py,tile,player.facing,player.moving,player.animTick);
    if(zone.outside){
      const ov=time.getOverlay();
      if(ov.alpha>0){
        ctx.fillStyle=ov.color; ctx.globalAlpha=ov.alpha; ctx.fillRect(0,0,w,h); ctx.globalAlpha=1;
        if(time.phase==='noche'){
          ctx.fillStyle='rgba(255,255,255,.9)';
          for(let i=0;i<40;i++){
            const sx=(i*137+time.tick*800)%w, sy=(i*57)%(h*0.6);
            ctx.globalAlpha=0.6+Math.sin(time.tick*10+i)*0.3;
            ctx.fillRect(sx,sy,1.2,1.2);
          }
          ctx.globalAlpha=1;
        }
      }
    }
    drawMinimap();
  }

  function drawMinimap(): void {
    const mw=minimap.width, mh=minimap.height; mctx.clearRect(0,0,mw,mh);
    const scaleX=mw/zone.size.w, scaleY=mh/zone.size.h, scale=Math.min(scaleX,scaleY);
    const offX=(mw-zone.size.w*scale)/2, offY=(mh-zone.size.h*scale)/2;
    for(let y=0;y<zone.size.h;y++) for(let x=0;x<zone.size.w;x++){
      const tid=zone.map[y][x]; const def=TILE_DEFS[tid] ?? TILE_DEFS[0];
      mctx.fillStyle=def.color; mctx.fillRect(offX+x*scale, offY+y*scale, Math.ceil(scale), Math.ceil(scale));
    }
    mctx.fillStyle='#ff6b9d'; for(const n of npcs){ mctx.beginPath(); mctx.arc(offX+n.x*scale+scale/2, offY+n.y*scale+scale/2,1.8,0,Math.PI*2); mctx.fill(); }
    mctx.fillStyle='#ffcf6b'; for(const v of visibleSystem.getAll()){ mctx.beginPath(); mctx.arc(offX+v.x*scale+scale/2, offY+v.y*scale+scale/2,2.2,0,Math.PI*2); mctx.fill(); }
    // objetos ocultos en minimapa cian
    mctx.fillStyle='#7cf0ff'; for(const o of objectsInZone(zoneId)){ if(store.get().collectedObjects.includes(o.id) && !o.respawn) continue; mctx.beginPath(); mctx.arc(offX+o.x*scale+scale/2, offY+o.y*scale+scale/2,1.6,0,Math.PI*2); mctx.fill(); }
    mctx.fillStyle='#fff'; mctx.strokeStyle='#6a5cff'; mctx.lineWidth=1;
    mctx.beginPath(); mctx.arc(offX+player.x*scale, offY+player.y*scale,3,0,Math.PI*2); mctx.fill(); mctx.stroke();
    mctx.strokeStyle='rgba(255,255,255,.18)'; mctx.strokeRect(offX,offY,zone.size.w*scale,zone.size.h*scale);
  }

  function drawAtlas(): void {
    const cv=mapOverlay.querySelector<HTMLCanvasElement>('[data-role="map-villa"]')!;
    const cr=mapOverlay.querySelector<HTMLCanvasElement>('[data-role="map-ruta"]')!;
    drawAtlasCanvas(cv,getZone('villa_aurelia'),'villa_aurelia');
    drawAtlasCanvas(cr,getZone('ruta_aurelia'),'ruta_aurelia');
  }
  function drawAtlasCanvas(c:HTMLCanvasElement,z:ReturnType<typeof getZone>,zid:ZoneId): void {
    const ctx2=c.getContext('2d')!; const W=c.width,H=c.height; ctx2.clearRect(0,0,W,H);
    const pad=8, availW=W-pad*2, availH=H-pad*2, sc=Math.min(availW/z.size.w, availH/z.size.h);
    const offX=pad+(availW-z.size.w*sc)/2, offY=pad+(availH-z.size.h*sc)/2;
    for(let y=0;y<z.size.h;y++) for(let x=0;x<z.size.w;x++){
      const tid=z.map[y][x]; const def=TILE_DEFS[tid] ?? TILE_DEFS[0];
      ctx2.fillStyle=def.color; ctx2.fillRect(offX+x*sc, offY+y*sc, Math.ceil(sc), Math.ceil(sc));
    }
    ctx2.fillStyle='#ffcf6b'; for(const w of z.warps) ctx2.fillRect(offX+w.x*sc, offY+w.y*sc, sc, sc);
    ctx2.fillStyle='#ff6b9d'; for(const n of npcsInZone(zid as any)) ctx2.beginPath(), ctx2.arc(offX+n.x*sc+sc/2, offY+n.y*sc+sc/2, Math.max(2, sc*0.4),0,Math.PI*2), ctx2.fill();
    if(zid==='ruta_aurelia'){
      ctx2.fillStyle='#ffcf6b';
      for(const v of visibleSystem.getAll()){ ctx2.beginPath(); ctx2.arc(offX+v.x*sc+sc/2, offY+v.y*sc+sc/2, 2.5,0,Math.PI*2); ctx2.fill(); }
      ctx2.fillStyle='#7cf0ff';
      for(const o of objectsInZone(zid as any)){ if(store.get().collectedObjects.includes(o.id) && !o.respawn) continue; ctx2.beginPath(); ctx2.arc(offX+o.x*sc+sc/2, offY+o.y*sc+sc/2, 2,0,Math.PI*2); ctx2.fill(); }
    }
    if(zid===zoneId){
      ctx2.fillStyle='#fff'; ctx2.strokeStyle='#6a5cff'; ctx2.lineWidth=2;
      ctx2.beginPath(); ctx2.arc(offX+player.x*sc, offY+player.y*sc, sc*0.7,0,Math.PI*2); ctx2.fill(); ctx2.stroke();
    }
    ctx2.strokeStyle='rgba(0,0,0,.12)'; ctx2.strokeRect(offX,offY,z.size.w*sc,z.size.h*sc);
  }

  function toast(msg:string): void {
    let stack=document.querySelector<HTMLDivElement>('.toast-stack');
    if(!stack){ stack=document.createElement('div'); stack.className='toast-stack'; document.body.appendChild(stack); }
    const t=document.createElement('div'); t.className='toast'; t.textContent=msg; stack.appendChild(t); setTimeout(()=>t.remove(), 2800);
  }

  let raf=0;
  function loop(now:number): void {
    const dt=Math.min(0.05,(now-lastTime)/1000); lastTime=now;
    update(dt); if(!battle.isVisible()||true) render();
    if(dialogue.isActive()){
      dlgName.textContent=dialogue.getSpeaker();
      dlgText.textContent=dialogue.getVisibleText();
    }
    raf=requestAnimationFrame(loop);
  }

  camera.snap({x:player.x*GAME_CONFIG.tileSize, y:player.y*GAME_CONFIG.tileSize}, {w:zone.size.w*GAME_CONFIG.tileSize, h:zone.size.h*GAME_CONFIG.tileSize});
  audio.playMusic(zone.musicKey as any);
  zoneLabel.textContent=zone.label; timeLabel.textContent=time.getLabel(); refreshHud();
  lastTime=performance.now(); raf=requestAnimationFrame(loop);
  setTimeout(()=> canvas.focus(),100);
  (wrap as any).destroy=()=>{
    cancelAnimationFrame(raf); input.detach();
    window.removeEventListener('resize', resizeCanvas);
  };
  canvas.addEventListener('click',()=>{ if(!dialogue.isActive()&& !battle.isVisible()&& !menuOpen && !shopOverlay) tryInteract(); else if(dialogue.isActive()) dialogue.advance(); });
  canvas.addEventListener('keydown',(e)=>{
    if(e.key===' '||e.key==='Enter'){ e.preventDefault(); tryInteract(); }
    if(e.key==='m'||e.key==='M') toggleMap();
    if(e.key==='t'||e.key==='T') toggleMenu();
    if(e.key==='Escape'){ if(dialogue.isActive()){ dialogue.close(); dialogueEl.style.display='none'; } else if(mapOpen) toggleMap(false); else if(menuOpen){ menuOverlay?.remove(); menuOverlay=null; menuOpen=false; } else if(shopOverlay){ shopOverlay.remove(); shopOverlay=null; } else if(battle.isVisible()){} }
  });

  // misiones iniciales: desbloquear disponibles
  MissionSystem.refreshMissions(store.get());
  // descubrir zona inicial
  MissionSystem.updateObjective(store.get(), 'visitar_zona', zoneId, 1);

  return wrap;
}
